import { useQuery } from '@tanstack/react-query';
import { currentSession } from './passwordSession';

/**
 * Who is signed in, as a query both shells share (`['session']`): the
 * community top bar, the viewer's Discussion in either edition. Null is a
 * guest; undefined, not answered yet.
 */
export function useSession() {
  return useQuery({ queryKey: ['session'], queryFn: currentSession, staleTime: 5 * 60_000 });
}
